import { render, staticRenderFns } from "./livraison-mode.vue?vue&type=template&id=2d29829c&scoped=true&"
import script from "./livraison-mode.vue?vue&type=script&lang=js&"
export * from "./livraison-mode.vue?vue&type=script&lang=js&"
import style0 from "./livraison-mode.vue?vue&type=style&index=0&id=2d29829c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d29829c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d29829c')) {
      api.createRecord('2d29829c', component.options)
    } else {
      api.reload('2d29829c', component.options)
    }
    module.hot.accept("./livraison-mode.vue?vue&type=template&id=2d29829c&scoped=true&", function () {
      api.rerender('2d29829c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/livraisons/livraison-mode.vue"
export default component.exports